import type { ReactNode } from 'react';

import { cx } from './classNames';
import { Icon } from './Icon';

/** Leerzustand einer Liste oder eines Bereichs (REQ-25 §3): Symbol, Titel, eine Zeile Erklärung. */
export interface EmptyStateProps {
  title: string;
  description?: string;
  /** Font-Awesome-Angabe, z. B. 'fa-solid fa-clock-rotate-left'. */
  iconClass?: string;
  action?: ReactNode;
  size?: 'sm' | 'md';
}

export function EmptyState(props: EmptyStateProps) {
  const size = props.size ?? 'md';

  return (
    <div className={cx('iwm-state', `iwm-state--${size}`)}>
      <span className="iwm-state-icon">
        <Icon iconClass={props.iconClass ?? 'fa-solid fa-inbox'} />
      </span>
      <p className="iwm-state-title">{props.title}</p>
      {props.description === undefined ? null : (
        <p className="iwm-state-description">{props.description}</p>
      )}
      {props.action === undefined ? null : <div className="iwm-state-action">{props.action}</div>}
    </div>
  );
}

export default EmptyState;
